var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutSuccessfully(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.667 50.2466V54.9999C106.66 66.1415 103.053 76.9824 96.3817 85.906C89.7107 94.8296 80.3338 101.358 69.6495 104.517C58.9652 107.676 47.546 107.296 37.0949 103.435C26.6439 99.5742 17.7209 92.4381 11.6568 83.0915C5.59271 73.7448 2.71242 62.6883 3.44549 51.5709C4.17857 40.4535 8.48573 29.871 15.7246 21.4015C22.9635 12.932 32.7462 7.02943 43.6138 4.57404C54.4814 2.11865 65.8516 3.24202 76.0285 7.77662",
    stroke: "#026F30",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 27.6665L35 79.3848L19.5 63.8848",
    stroke: "#026F30",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutSuccessfully);
export default __webpack_public_path__ + "static/media/checkout-successfully.878d91f21d003d8808a08c28a0d136fe.svg";
export { ForwardRef as ReactComponent };